import { ProjectMember } from '../../../services/projects';
import { AssignedAgent } from '../../../services/agents';

/**
 * Extended ProjectMember type that includes AI agent properties
 */
export interface ExtendedProjectMember extends ProjectMember {
  // AI agent specific properties
  isAI?: boolean;
  name?: string;
  description?: string;
  department?: string;
  id?: string;
}

/**
 * Convert an AssignedAgent to an ExtendedProjectMember
 */
export const agentToMember = (agent: AssignedAgent): ExtendedProjectMember => {
  return {
    email: agent.agent_id, // Use agent_id as email for identification
    role: agent.role as any, // Cast to ProjectMember role
    status: 'active', // AI agents are always active
    isAI: true,
    name: agent.name,
    description: agent.description,
    department: undefined, // Department is not available in AssignedAgent
    id: agent.agent_id
  };
};

/**
 * Convert a regular ProjectMember to an ExtendedProjectMember
 */
export const extendMember = (member: ProjectMember): ExtendedProjectMember => {
  return {
    ...member,
    isAI: false
  };
};
